import { jsx } from 'react/jsx-runtime';
import { createElement } from 'react';
import { IconWrapper } from '../IconWrapper/IconWrapper.js';
import '../../../tslib.es6-a39f91fc.js';
import '../../../index-6ea95111.js';
import '../../../style-inject.es-1f59c1d0.js';

var ChevronUpIcon = (function (props) {
    return createElement(IconWrapper, props, jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2.4, d: "M19.2 14.6 12 7.4l-7.2 7.2" }));
});

export default ChevronUpIcon;
//# sourceMappingURL=ChevronUp.js.map
